<template>
  <datepicker ref="datepickerForfait"
    v-model="datepickerForfait"
    v-on:selected="selectedDate"
    :placeholder="i18n.t('when.placeholder')"
    :input-class="'datepicker-input'"
    :format="format"
    :language="languages[language]"
    :disabledDates="disabledDates"
    :disabledCapacityDates="disabledCapacityDates"
    :daysWithcustomClass="customClasses"
    :mondayFirst="true"
    :minimumView="'day'"
    :maximumView="'day'"
    :highlighted="highlighted"
    :open-date="openDate(Object.keys(this.dataCalendar).sort())"
    :full-month-name="true">
        <div slot="beforeCalendarHeader" class="tabs-container">
            <div class="calendar-bar w-full bg-grey-bg p-0 h-12 lg:hidden">
                <span @click="closeCalendar" class="material-icons close text-black absolute bg-white rounded-full p-1">close</span>
                <h1 class="text-xl text-center text-black pt-2">{{ $t("when.placeholder") }}</h1>
            </div>
            <div id="tab-calendar" class="w-full py-3 font-medium tabs-calendar text-center tracking-widest active">
                <img class="inline-block w-6 mb-1 mr-4" src="../../../assets/img/icon-calendar.svg" />
                <span class="inline-block uppercase">{{ $t("when.calendar") }}</span>
            </div>
        </div>
        <div slot="afterCalendar">
            <div class="px-8 pt-2 pb-24">
                <div v-if="hasLowCapacity">
                    <span class="text-capacity-low text-2xl align-middle">•</span>
                    <span class="text-1xs text-grey-text ml-1">{{ $t("when.tickets_available", [capacityUpperTreshold]) }}</span>
                </div>
                <div v-if="hasHighCapacity">
                    <span class="text-capacity-high text-2xl align-middle">•</span>
                    <span class="text-1xs text-grey-text ml-1">{{ $t("when.tickets_available", [capacityLowerTreshold]) }}</span>
                </div>
                <div v-if="hasDisabledCapacityDates">
                    <span class="text-full text-2xl align-middle">•</span>
                    <span class="text-1xs text-grey-text ml-1">{{ $t("when.full") }}</span>
                </div>
                <div v-if="hasHighlighted">
                    <span class="text-info text-2xl align-middle">•</span>
                    <span class="text-1xs text-grey-text ml-1">{{ $t("when.reduced") }}</span>
                </div>
            </div>
            <div class="w-full px-1 border-t border-grey-border cursor-pointer sticky-bottom lg:absolute" v-if="datepickerForfait !== null && datepickerForfait !== ''">
                <div class="rounded my-2 py-1 w-full bg-secondary text-white text-center" v-on:click="closeCalendar">
                    <div>
                        <span class="text-xl">{{$t("when.continue")}}</span>
                    </div>
                    <div>
                        <span>{{ DateTime.fromJSDate(datepickerForfait) | shortDate }}</span>
                    </div>
                </div>
            </div>
        </div>
    </datepicker>
</template>

<script>
import Datepicker from 'vuejs-datepicker-aftercalendarslot';
import * as lang from "vuejs-datepicker-aftercalendarslot/src/locale";
import { DateTime } from "luxon";
import i18n from "../../../i18n";
import { mapGetters } from 'vuex';

export default {
    name: "ria-datepicker",
    components: {
        Datepicker
    },
    data() {
        return {
            capacityUpperTreshold: process.env.VUE_APP_CAPACITY_UPPER_TRESHOLD,
            capacityLowerTreshold: process.env.VUE_APP_CAPACITY_LOWER_TRESHOLD,
            i18n: i18n,
            datepickerForfait: "",
            format: "d MMMM yyyy",
            language: this.$store.getters["device/language"],
            languages: lang,
            disabledDates: {
                to: this.checkTo(Object.keys(this.dataCalendar).sort()),
                from: this.checkFrom(Object.keys(this.dataCalendar).sort()),
                dates: []
            },
            disabledCapacityDates: {
                dates: []
            },
            highlighted: {
                dates: []
            },
            customClasses: {},
            hasLowCapacity: false,
            hasHighCapacity: false,
            hasHighlighted: false,
            hasDisabledCapacityDates: false,
            DateTime: DateTime
        };
    },
    computed: {
        ...mapGetters('resort', ['selectedProduct', 'resort']),
        ...mapGetters('order', ['details'])
    },
    methods: {
        closeCalendar(){
            this.$refs.datepickerForfait.close();
        },
        selectedDate(){
            this.$nextTick(() => {
                this.$emit('selectedDate', DateTime.fromJSDate(this.datepickerForfait).toFormat('yyyy-LL-dd'))
                this.$refs.datepickerForfait.showCalendar()
                }
            );
        },
        openDate(to){
            if(this.datepickerForfait !== undefined && this.datepickerForfait !== "")
                return this.datepickerForfait
            else
                return this.checkTo(to)
        },
        checkFrom(from){
            if(Object.entries(this.dataCalendar).length < 2)
                return new Date()
            
            const last = new Date(from[from.length-2]);
            last.setDate(last.getDate()+1);
            return last;
        
        },
        checkTo(to){
            if(Object.entries(this.dataCalendar).length < 2)
                return new Date()
            
            const today = this.changeTime(new Date);
            const first = this.changeTime(new Date(to[0]));
            return (first < today) ? today : first;
        },
        checkDates(dates){
            let disabledList = []
            let disabledCapacityList = []
            const sortedList = Object.keys(dates).sort();
            const startDate = sortedList[0];
            const endDate = sortedList[sortedList.length-2];
            let dateMove = new Date(startDate);
            let strDate = startDate;
            const today = new Date().toISOString().substring(0,10);

            while (strDate <= endDate){
                strDate = dateMove.toISOString().slice(0,10);
                const actualDate = new Date(strDate);
                const dayofweek = DateTime.fromJSDate(actualDate, {locale: 'en'}).weekdayLong.toLowerCase()
                if(!sortedList.includes(strDate))
                    disabledList.push(actualDate);
                else if(!this.selectedProduct.restrictions[dayofweek])
                    disabledList.push(actualDate);
                else if(this.resort.capacity && this.selectedProduct.days){
                    const capacity = Object.entries(this.dataCalendar[strDate]).find(date => date[1].capacity != null);
                    if(this.selectedProduct.days > 1){ 
                        let days = this.selectedProduct.days -1
                        let someDay = false
                        let missingDay = false
                        while(days > 0){
                            const futureDay = DateTime.fromJSDate(actualDate, {locale: 'en'}).plus({days: days})
                            if(!this.dataCalendar[futureDay.toISODate()])
                                missingDay = true
                            else{
                                const capacityFuture = Object.entries(this.dataCalendar[futureDay.toISODate()]).find(date => date[1].capacity != null)
                                if(capacityFuture != undefined && capacityFuture[1].capacity <= 0){
                                    someDay = true;
                                }
                            }
                            days--
                        }
                        if(someDay || (capacity && !(capacity[1].capacity > 0))){
                            disabledCapacityList.push(actualDate)
                        }
                        if(missingDay){
                            disabledList.push(actualDate)
                        }
                    }
                    else if(this.selectedProduct.days === 1){
                        if(capacity && !(capacity[1].capacity > 0))
                            disabledCapacityList.push(actualDate)
                    }

                    if (capacity !== undefined) {
                        if (
                            capacity[1].capacity < this.capacityUpperTreshold &&
                            capacity[1].capacity >= this.capacityLowerTreshold 
                        ) {
                            this.hasLowCapacity = true
                            this.customClasses[strDate] = 'bg-capacity-low'
                        }

                        if (
                            capacity[1].capacity < this.capacityLowerTreshold && 
                            capacity[1].capacity >= 1
                        ) {
                            this.hasHighCapacity = true
                            this.customClasses[strDate] = 'bg-capacity-high'
                        }
                    }
                }

                dateMove.setDate(dateMove.getDate()+1);
            }

            this.disabledCapacityDates.dates = disabledCapacityList
            this.hasDisabledCapacityDates = disabledCapacityList.length > 0
            
            dateMove = new Date(startDate);
            strDate = startDate;

            while(strDate < today){
                strDate = dateMove.toISOString().slice(0, 10);
                disabledList.push(new Date(strDate));
                dateMove.setDate(dateMove.getDate()+1)
            }

            this.highlighted.dates = [...Object.entries(dates).slice(1)]
                .filter(date => Object.values(date[1]).some(participant => participant.best_amount !== participant.original_amount))
                .map(date => new Date(date[0]))
            
            this.hasHighlighted = this.highlighted.dates.length > 0

            this.disabledDates.dates = disabledList;
        },
        changeTime(date){
            date.setHours(0, 0, 0, 0)
            return date
        }
    },
    created() {
        if(Object.entries(this.dataCalendar).length >= 2){
            this.checkDates(this.dataCalendar)
        }
        if(this.details.length > 0){
            this.datepickerForfait = new Date(this.details[0].date)
            this.selectedDate
        }
    },
    props: {
        dataCalendar: Object
    },
};
</script>

<style>
    .material-icons.close{
        top: 8px;
        left: 8px;
    }
    .calendar-bar{
        height: 46px;
    }
    .tabs-container{
        box-shadow: 0px -10px 60px -15px rgba(0,0,0,0.2);
    }
    .tabs-calendar.active{
        border-bottom: solid 4px;
        border-color: var(--secondary-color);
    }
    .datepicker-input{
        @apply w-full p-4 rounded font-medium text-lg border border-black cursor-pointer;
        background: url(/img/icons/icon-grey-calendar.svg) no-repeat right 10px top 11px;
    }
    .datepicker-input::placeholder{
        @apply text-black text-opacity-100;
    }
    .vdp-datepicker{
        @apply w-full !important;
    }
    .vdp-datepicker__calendar{
        @apply w-full fixed top-0 left-0 h-auto border-0 bottom-0 overflow-y-auto !important;
    }
    .vdp-datepicker__calendar #calendar-days{
        padding: 0px 30px 15px 30px;
    }
    .vdp-datepicker__calendar .day__month_btn{
        @apply lowercase font-medium;
    }
    .vdp-datepicker__calendar .day-header{
        color: #8c9aad;
        text-transform: uppercase;
        margin: 5px 0px;
    }
    .vdp-datepicker__calendar .cell{
        border: solid 1px white !important;
        border-radius: 3px;
        height: 50px !important;
        line-height: 50px !important;
    }
    .vdp-datepicker__calendar .selected{
        background-color: #0c2340 !important;
        color: white;
    }
    .vdp-datepicker__calendar header{
        padding: 30px;
    }
    .vdp-datepicker__calendar :not(header) .disabled{
        @apply bg-grey-bg text-grey-text;
    }
    .vdp-datepicker__calendar .highlighted:not(.bg-capacity-high):not(.bg-capacity-low){
        @apply bg-white;
    }

    .vdp-datepicker__calendar .selected{
        @apply bg-marine !important;
    }
    .vdp-datepicker__calendar .highlighted.disabled::after,
    .vdp-datepicker__calendar .highlighted.disabledFull::after {
        content: "";
    }

    .vdp-datepicker__calendar .highlighted.selected::after{
        content: "";
    }
    .vdp-datepicker__calendar .highlighted::after{
        content: "·";
        top: -35px;
        @apply text-info text-5xl relative block;
    }
    .vdp-datepicker__calendar .disabledFull {
        @apply cursor-default bg-full !important;
    }
    #reduced-price{
        @apply p-0;
        
    }
    @screen lg {
        .vdp-datepicker__calendar{
            width: 400px !important;
            @apply h-auto relative top-auto left-auto border border-grey-border !important;
        }
        .datepicker-input{
            width: 70%;
        }
    }
</style>
